// extracted by mini-css-extract-plugin
module.exports = {"icon":"svg-arrow_icon__fVlCQ"};